import {UseVaccineType} from '@/common/Enum/UseVaccineType.Enum';
import {CommonModule} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {MedicationService} from '@services/medication.service';
import {SupplierService} from '@services/supplier.service';
@Component({
    selector: 'app-medication-record',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './medication-record.component.html',
    styleUrl: './medication-record.component.scss'
})
export class MedicationRecordComponent implements OnInit {
    @Input() medicationName: string | null = null;
    @Input() medication: any | null = null;
    @Input() placement: any | null = null;
    @Input() indication: string | null = null;
    @Input() method: UseVaccineType | null = null;
    @Input() batch: string | null = null;
    @Input() dose: number | string | null = null;
    @Input() dosageUnit: string = 'Quantity(Box)';
    @Input() duration: number | string | null = null;
    @Input() supplier: string | null = null;
    @Input() notes: string | null = null;
    @Input() recordDate: string | Date | null = null;
    @Input() birdCount: string | number | null = null;
    @Input() ageIndicator: string | null = null;

    constructor(
        private medicationService: MedicationService,
        private supplierService: SupplierService
    ) {}

    ngOnInit(): void {
        if (this.medication && this.medication.brandId) {
            this.GetMedicationDetailsById(this.medication.brandId);
        }
    }

    GetMedicationDetailsById(MedicationId: any) {
        this.medicationService.getMedicationById(MedicationId).subscribe({
            next: (response: any) => {
                if (response) {
                    this.medicationName = response.name;
                    this.batch = response.batchNumber;

                    if (response.supplierId) {
                        this.getSupplierName(response.supplierId);
                    }
                }
            }
        });
    }

    getSupplierName(supplierId: number) {
        this.supplierService.getSupplierById(supplierId).subscribe({
            next: (response: any) => {
                if (response) {
                    this.supplier = response.name;
                }
            },
            error: () => {
                this.supplier = null;
            }
        });
    }
}
